import { normalizeInputDigits } from './inputDigits';

// Convert Bengali decimal digits before the existing duration-only filter.
// State stays ASCII so preset selection, preview arithmetic and API submission
// all consume the same value. This is not a money, phone or OTP parser.
export function sanitizeDurationInput(input: string, language: string): string {
  return normalizeInputDigits(input, language).replace(/[^0-9]/g, '');
}

// Same bounds as the reservation API. One value drives preview and submission.
export function parseDurationInput(input: string): number | null {
  if (!/^\d+$/.test(input)) return null;
  const minutes = Number(input);
  return Number.isInteger(minutes) && minutes >= 1 && minutes <= 480 ? minutes : null;
}
